export default __webpack_public_path__ + "static/media/004-telephone booth.c3977c90.svg";